import React from 'react'
import { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogTitle, Typography } from "@mui/material"

import { AnswersType } from '../Models/AnswersType';

import ConfirmationModal from './ConfirmationModal';

import { useContext } from 'react';
import { PolyglotContext } from '../../../polyglot/polyGlotContext';

interface EndCurrentModalProps {
    endCurrentClicked: boolean;
    setEndCurrentClicked: (exit: boolean) => void;
    setCollectedAnswers: React.Dispatch<React.SetStateAction<AnswersType>>;
    setPageToStart: () => void;
    collectedAnswersCopy: AnswersType
}

//This modal is for confirming abortion of current question, and returning to start.
const EndCurrentModal: React.FC<EndCurrentModalProps> = ({ endCurrentClicked, setEndCurrentClicked, setCollectedAnswers, setPageToStart, collectedAnswersCopy }) => {
    const { polyglot } = useContext(PolyglotContext)

    //State to open ConfirmationModal
    const [ActivateConfirmationModal, setActivateConfirmationModal] = useState(false);

    //Modal Logic
    const [openModal, setOpenModal] = React.useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
        setEndCurrentClicked(false);
    };
    useEffect(() => {
        if (endCurrentClicked) {
            setOpenModal(true);
        }
    }, [endCurrentClicked])

    const handleEnd = () => {
        setActivateConfirmationModal(true)
        setCollectedAnswers({});
        handleCloseModal();
    }

    const currentQuestionIndexValue = Object.keys(collectedAnswersCopy).length + 1

    return (
        <>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={false}
                PaperProps={{ sx: { padding: "3rem" } }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant="h1"
                        sx={{
                            border: "solid 3px #41b771",
                            borderRadius: "40px",
                            py: 8,
                            px: 5,
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        {`${polyglot.t("evaluationTool.endCurrentModal.h1")} ( ${currentQuestionIndexValue} )?`}
                    </Typography>
                </DialogTitle>
                <DialogActions sx={{ alignItems: "center", justifyContent: "center", mt: "1rem" }}>
                    <Button onClick={handleCloseModal} variant="outlined" color="secondary" sx={{ mx: "3rem", fontSize: "2.5rem" }}>{polyglot.t("evaluationTool.endCurrentModal.noBtn")}</Button>
                    <Button onClick={handleEnd} variant="contained" color="error" sx={{ mx: "3rem", fontSize: "2.5rem" }}>{polyglot.t("evaluationTool.endCurrentModal.yesBtn")}</Button>
                </DialogActions>
            </Dialog>
            <ConfirmationModal textContent={polyglot.t("evaluationTool.endCurrentModal.confirmationTextContent")} activated={ActivateConfirmationModal} setActivated={setActivateConfirmationModal} setPage={setPageToStart}></ConfirmationModal>
        </>
    )
}

export default EndCurrentModal
